import { z } from 'zod';

import {
  productListSearchParams,
  productListSearchSchema as productSearchSchema,
} from '@/features/resource-pickers';

import type { ProductListParams } from '../api/products-api';
import { LEGACY_PRODUCT_PARAMS, PRODUCT_SORTS } from '../components/product-filters';

/**
 * URL search params of the products list route; mirrors GET /admin/v1/org/products with the
 * product filters the picker shares (D-182). `tag` and `storeId` links still work. Lazy: the
 * feature doors import each other in a ring, so the schema is built on first use.
 */
export const productListSearchSchema = z.lazy(() =>
  productSearchSchema('org', { sort: PRODUCT_SORTS, legacy: LEGACY_PRODUCT_PARAMS }),
);

export type ProductListSearch = z.infer<typeof productListSearchSchema>;

/**
 * The list request for a validated search, `includeTotal` on the first page; the page's
 * `useSearchListState().params` (through `withFirstPageTotal`) match it.
 */
export function productListParams(search: ProductListSearch): ProductListParams {
  return productListSearchParams(search, 'org');
}
